import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../../../ai-suite/theme';

/** A small centred pill in a thread: the scene at the top, the result at the end. */
export const ScenePill = memo(
  ({ text, outlined }: { text: string; outlined?: boolean }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ alignItems: 'center' }}>
        <View
          style={{
            borderRadius: rpx(999),
            paddingHorizontal: rpx(12),
            paddingVertical: rpx(4),
            backgroundColor: outlined ? aiColors.card : aiColors.muted,
            borderWidth: outlined ? 1 : 0,
            borderColor: aiColors.border,
          }}
        >
          <Typography.Text
            size={rpx(outlined ? 11 : 10)}
            bold={outlined || undefined}
            color={
              outlined ? aiColors.accentForeground : aiColors.mutedForeground
            }
          >
            {text}
          </Typography.Text>
        </View>
      </View>
    );
  },
);
